import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllEntitiesByPersonUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllEntitiesByPerson
  implements GetAllEntitiesByPersonUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllEntitiesByPersonUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetAllEntitiesByPersonUseCaseInterface.Params,
  ): Promise<GetAllEntitiesByPersonUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, {
        personHashId: params.personHashId,
        // summary: params.summary
      }),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
